import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, Inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import colorsJsonGreen from '../../../../assets/teiasoft-themes/green.json';
import colorsJsonBlue from './../../../../assets/teiasoft-themes/blue.json';
import colorsJsonSilver from './../../../../assets/teiasoft-themes/silver.json';
import { Globals } from '../../../shared/globals/globals';
import { TeiasoftHeaderService } from '../../services/teiasoft-bucket/teiasoft-header.service';

import { TeiasoftToasterService } from '../../services/teiasoft-bucket/teiasoft-toaster.service';
import { TeiasoftSpeechRecognitionService } from '../../services/teiasoft-bucket/teiasoft-speech-recognition.service';
import { VoiceCommand } from '../../models/app/voiceCommand.model';
import { UtilsService } from '../../services/utils/utils.service';
import { AppLanguage } from '../../models/app/appLanguage.model';
import { UserConfiguration } from '../../models/data/userConfiguration.model';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { GroupAuthorization } from '../../models/data/groups.model';
import { GlobalClickService } from '../../services/global-click/global-click.service';
import { ThemeService } from '../../services/utils/theme.service';

export class IMenu {
  page!: string;
  icon!: string;
  iconActive!: string;
  enabled!: boolean;
  tooltip!: string;
  label!: string;
  isMobile!: boolean;
  authorization?: string[];
  action?: string;
}

@Component({
  selector: 'teiasoft-header',
  templateUrl: './teiasoft-header.component.html',
  styleUrls: ['./teiasoft-header.component.scss'],
  providers: [
    // The locale would typically be provided on the root module of your application. We do it at
    // the component level here, due to limitations of our example generation script.
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' }
  ]
})

export class TeiasoftHeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() title: string = "TEIASOFT Wiki Web Controls";
  @Input() userName: string = "Anonymous";
  @Input() theme: string = "silver";
  @Input() pathLogo: string = "";
  @Input() headerHidePages: string[] = new Array();
  @Input() isMobile: boolean = false;
  @Input() showSettings: boolean = false;
  @Input() user?: { userAuthorizations?: GroupAuthorization[] };


  @Output() onClick: EventEmitter<IMenu> = new EventEmitter();
  @Output() onChangeUsersSettings: EventEmitter<any> = new EventEmitter();

  page: string = "home";
  menuCfg: IMenu[] = new Array();
  isMenuOpen: boolean = false;
  appVersion: string = "Version 1.0.1";
  openSettings: boolean = false;
  languages: AppLanguage[] = new Array();
  dateFormats: string[] = ['dd/MM/yyyy', 'MM/dd/yyyy'];


  constructor(private router: Router, public globals: Globals, private themeService: ThemeService, private teiasoftHeaderService: TeiasoftHeaderService,
    private teiasoftToasterService: TeiasoftToasterService, private utilsService: UtilsService,
    private speechRecognitionService: TeiasoftSpeechRecognitionService, private _adapter: DateAdapter<any>,
    private _intl: MatDatepickerIntl,
    private globalClickService: GlobalClickService,
    @Inject(MAT_DATE_LOCALE) private _locale: string) {
    this.getHeaderMenu();
  }

  ngOnInit(): void {
    this.loadTheme();
    this.page = this.getCurrentPage();
    if (this.showSettings) {
      this.getLanguages();
    }
    //if (this.page == '') this.page = 'home';
    this.globalClickService.registerComponent(this);
  }

  ngOnDestroy(): void {
    this.globalClickService.unregisterComponent(this);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["theme"]) {
      this.theme = changes["theme"]["currentValue"];
      this.loadTheme();
    }

    if (changes && changes["headerHidePages"]) {
      this.headerHidePages = new Array();
      this.headerHidePages = changes["headerHidePages"]["currentValue"];
    }

    if (changes && changes["showSettings"]) {
      this.showSettings = changes["showSettings"]["currentValue"];
    }

    if (changes['user']) {
      this.getHeaderMenu();
    }
  }

  handleClickOutside(event: Event) {
    let _className: string = (event.target as HTMLElement).className!;
    if (!_className.includes("th-ico-settings") && !_className.includes('th-settings-cnt')) {
      this.openSettings = false;
    }
  }

  getLanguages() {
    this.utilsService.getLanguages().subscribe(res => {
      this.languages = new Array();
      if (res) {
        this.languages = res;
      }
    });
  }

  getHeaderMenu() {
    this.menuCfg = [];

    this.teiasoftHeaderService.getHeadermenu().subscribe(res => {
      const items = (res ?? []).filter(x => x.isMobile === this.isMobile);

      const userGlobalAuthorizations =
        this.globals.userLogged?.userAuthorizations?.find(ua => ua.unitType === 'Global');
      const officeAuthorizations =
        this.globals.userLogged?.userAuthorizations?.find(ua => ua.unitType === 'Office');
      const millAuthorizations =
        this.globals.userLogged?.userAuthorizations?.find(ua => ua.unitType === 'Mill');

      const authsOf = (ga?: GroupAuthorization) => ga?.authorizations ?? [];

      // merge all available authorizations 
      const mergedAuthorizations = new Set<string>([
        ...authsOf(userGlobalAuthorizations),
        ...authsOf(officeAuthorizations),
        ...authsOf(millAuthorizations),
      ]);

      // if the user has no auths at all, only show items with no auth requirement
      this.menuCfg = items.filter(menuItem => {
        const required = menuItem.authorization ?? [];
        if (required.length === 0) return true; // no auth required
        // at least one required auth must be present
        return required.some(r => mergedAuthorizations.has(r));
      });
    });
  }


  showMe(): boolean {
    this.page = this.getCurrentPage();
    if (!this.headerHidePages || this.headerHidePages.length == 0) return false;
    if (this.headerHidePages.findIndex(x => x == this.page) == -1)
      return true;
    else
      return false;
  }

  private getCurrentPage(): string {
    return this.router.url.replace("/", "").split("?")[0];
  }

  identify(index: any, item: IMenu) {
    return item.label;
  }

  /**
   * SET SCSS VARIABLES
   */
  public loadTheme(): void {
    this.themeService.loadTheme(this.theme);

  }

  /*** NAVITAGE TO */
  onNavigateTo(page: string) {
    if (this.page == page) return;
    this.router.navigate(["/" + page]);
    this.page = page;
  }

  onMenuClick(item: IMenu) {
    this.openSettings = false;
    //let _page: string = window.location.hash.replace("#/", "");
    let _page: string = this.router.url.replace("/", "").split("?")[0];
    if (_page == item.page) return;
    if (item.enabled == false) return;
    this.onClick.emit(item);
    this.page = item.page;
    if (this.isMobile && this.isMenuOpen) this.onClickMenu();
  }

  onMenuClickMobile(item: IMenu) {
    this.onMenuClick(item);
  }

  getIconClass(item: IMenu): string {
    //let _page: string = window.location.hash.replace("#/", "");
    let _page: string = this.router.url.replace("/", "").split("?")[0];

    if (_page == 'groups') _page = 'users';

    // CHECK AUTH
    let _temp: GroupAuthorization = new GroupAuthorization();
    _temp = this.globals.userLogged!.userAuthorizations!.filter(x => x.unitType == 'Global')[0];
    // MP: deprecated beacuse we hide actions when not authorized
    // if (item.authorization != '' && _temp.authorizations!.findIndex(x => x == item.authorization) == -1) item.enabled = false; 

    let _ico: string = "";
    if (item.enabled == false) {
      _ico = item.icon + " th-ico-disabled";
    } else {
      if (_page != item.page) {
        _ico = item.icon + " th-ico";
      } else {
        _ico = item.iconActive + ' th-ico-active';
      }
    }
    return _ico;
  }

  onOpenSettingsClick() {
    this.openSettings = !this.openSettings;
  }


  /**
  * GENERAL - SET THEME
  */
  setTheme(evt: any, theme: string) {
    this.globals.theme = theme;
    let _conf: UserConfiguration = new UserConfiguration();
    _conf = JSON.parse(this.globals.userLogged!.configuration!);
    _conf.theme = theme;
    this.globals.userLogged!.configuration = JSON.stringify(_conf);
    localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged!));
    this.onChangeUsersSettings.emit(this.globals.userLogged!.language);
    //this.openSettings = false;
  }

  /** MOBILE */
  onClickMenu() {
    let _elem = document.getElementById('cntMenuMobile');
    if (!this.isMenuOpen) {
      _elem!.classList.add('th-menu-show');
      _elem!.classList.remove('th-menu-hide');
    } else {
      _elem!.classList.add('th-menu-hide');
      _elem!.classList.remove('th-menu-show');
    }

    setTimeout(() => this.isMenuOpen = !this.isMenuOpen, 200);
  }

  /* GENERAL - SET LANGUAGE */
  onSetLanguage(evt: any, lang: string) {
    this.globals.userLogged!.language = lang;
    localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged!));
    this.onChangeUsersSettings.emit(this.globals.userLogged!.language);
    //this.openSettings = false;

    this._locale = this.globals.userLogged!.language!.toLowerCase();
    this._adapter.setLocale(this._locale);
    this._intl.changes.next();
    this._adapter.getFirstDayOfWeek = () => { return (this._locale == 'en' ? 0 : 1); };
  }


  /* GENERAL - SET DATE FORMAT */
  onSetDateFormat(evt: any, format: string) {
    this.globals.userLogged!.dateFormat = format;
    localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged!));
    this.onChangeUsersSettings.emit(this.globals.userLogged!.dateFormat);

  }
  /*********************************************** SPEECH RECOGNITION ************************************************************/
  /*                                                                                                                             */
  /*******************************************************************************************************************************/
  processVoiceRecognition(phrase: string) {
    let _words: string[] = phrase.split(" ");
    if (this.globals.teiasoftSpeechRecognition!.voiceConfiguration!.startPhraseWith != '') {
      this.checkStartPhraseWith(_words[0]);
      if (!this.globals.teiasoftSpeechRecognition!.voiceListeningStarted) return;
    }
    if (!this.globals.teiasoftSpeechRecognition!.voiceListeningStarted && this.globals.teiasoftSpeechRecognition!.voiceConfiguration!.startSessionPhrase != '') {
      this.checkStartSessionPhrase(phrase);
      return;
    }
    if (this.globals.teiasoftSpeechRecognition!.voiceListeningStarted && this.globals.teiasoftSpeechRecognition!.voiceConfiguration!.endSessionPhrase != '') {
      this.checkEndSessionPhrase(phrase);
      if (!this.globals.teiasoftSpeechRecognition!.voiceListeningStarted) return;
    }

    // MATCH WITH VOICE COMMANDS
    let _command: VoiceCommand = new VoiceCommand();
    let _commandStart: string = this.globals.teiasoftSpeechRecognition!.voiceConfiguration!.startPhraseWith != '' ? _words[1] : _words[0];
    let _secondCommand: string = this.globals.teiasoftSpeechRecognition!.voiceConfiguration!.startPhraseWith != '' ? _words[2] : _words[1];
    if (_commandStart == 'esci') _commandStart = 'logout';
    _command = this.globals.teiasoftSpeechRecognition!.voiceCommands!.filter(x => x.command == _commandStart)[0];
    if (_command == undefined) {
      this.speechRecognitionService.playPhrase("Cosa intendi con " + phrase + "?");
    } else {
      // Navigate
      if (_command.action == "navigate") {
        if (_command.destination == 'last_word') {
          let _item: IMenu = new IMenu();
          _item = this.menuCfg.filter(x => x.page == (_words[_words.length - 1] == 'esci' ? 'logout' : _words[_words.length - 1]))[0];
          if (_item == undefined) {
            // INSERT AUTO LEARNING
            this.speechRecognitionService.playPhrase("Scusa, non capisco l'istruzione " + phrase + "?");
          } else {
            this.onMenuClick(_item);
          }
        } else {
          this.router.navigate(["/" + _command.destination]);
        }
      }

      // OPEN (Like Modal, etc...)
      if (_command.action == "open") {

      }

      // CHANGE (Like theme, language)
      if (_command.action == "change") {
        let _i: number = _command.secondCommand.split("|").indexOf(_secondCommand);
        let _destination: string = "";
        if (_i != -1) {
          if (_words.length == 2 || _words.length > 3) {
            this.speechRecognitionService.playPhrase("Scusa, per modificare le configurazioni di lingua e tema prova a dire: cambia tema verde o cambia lingua inglese");
          } else {
            _destination = _command.destination.split("|")[_i];
            if (_destination == 'theme') this.changeTheme();
            if (_destination == 'language') this.changeLanguage();
          }
        } else {
          // INSERT AUTO LEARNING
          this.speechRecognitionService.playPhrase("Scusa, non capisco l'istruzione " + phrase + "?");
        }
      }
    }
  }

  checkStartPhraseWith(word: string) {
    if (word != this.globals.teiasoftSpeechRecognition!.voiceConfiguration!.startPhraseWith) {
      this.speechRecognitionService.playPhrase("Devi iniziare ogni frase con " + this.globals.teiasoftSpeechRecognition!.voiceConfiguration!.startPhraseWith + "!");
      this.globals.teiasoftSpeechRecognition!.voiceListeningStarted = true;
    }
  }

  checkStartSessionPhrase(phrase: string) {
    if (phrase == this.globals.teiasoftSpeechRecognition!.voiceConfiguration!.startSessionPhrase) {
      this.globals.teiasoftSpeechRecognition!.voiceListeningStarted = true;
      this.speechRecognitionService.playPhrase("Ciao " + this.globals.userLogged!.name + ", sono in ascolto.");
    }
  }

  checkEndSessionPhrase(phrase: string) {
    if (phrase == this.globals.teiasoftSpeechRecognition!.voiceConfiguration!.endSessionPhrase) {
      this.speechRecognitionService.playPhrase("Ciao " + this.globals.userLogged!.name + ", ci sentiamo dopo.");
      this.globals.teiasoftSpeechRecognition!.voiceListeningStarted = false;
    }
  }

  changeTheme() {

  }

  changeLanguage() {

  }


}
